import React, { useState } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View, Platform } from 'react-native';
import headerImage from '../../assets/images/Fitbeat-focus-scale.jpg';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import Theme, { ThemeType } from '../../theme';
import { defaultScale, scaleImageAspectRatio, scaleText } from '../../utils/scaling';
import { WeightTargetImageHeader } from './weight-target-image-header';

const selectionOptionsConfig = [
  { title: 'No', subtitle: 'Manually track my target weight ', hasScale: false },
  { title: 'Yes', subtitle: 'Setup my smart scale and target', hasScale: true },
];

const WeightTargetFitillionScaleQuestionComponent = ({
  t,
  goToPreviousStep,
  userAnsweredHasScaleQuestion,
  hasScale,
  goToFaq,
}) => {
  return (
    <View style={{ flex: 1 }}>
      <WeightTargetImageHeader
        headerImage={headerImage}
        imageStyle={styles.imageStyle}
        hasGradient={true}
        goToPreviousStep={goToPreviousStep}
      >
        <View style={styles.imageContent}>
          <Text style={styles.doYouHaveAScale}>{t('doYouHaveAScale')}</Text>
          <Text style={styles.useOurSmartScale}>{t('useOurSmartScale')}</Text>
          <Button
            title={t('noScaleFindOutMore')}
            onPress={goToFaq}
            fontColor={Theme.PRIMARY}
            buttonType={ButtonTypes.TRANSPARENT}
            size={ButtonSize.NORMAL}
            containerStyle={{ marginBottom: defaultScale(20) }}
          />
        </View>
      </WeightTargetImageHeader>
      <View style={styles.selectionContainer}>
        {selectionOptionsConfig.map((option) => {
          return (
            <SelectionContainer
              title={option.title}
              style={styles.selectionStyle}
              subTitle={option.subtitle}
              isSelected={hasScale === option.hasScale}
              theme={ThemeType.light}
              onPress={() => {
                userAnsweredHasScaleQuestion(option.hasScale);
              }}
              height={defaultScale(100)}
              width={'100%'}
              titleStyle={styles.selectionTitle}
              subTitleStyle={styles.selectionSubtitle}
              overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
            />
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  imageStyle: {
    width: '100%',
    ...Platform.select({
      web: {
        height: '50vh',
      },
      default: {
        aspectRatio: scaleImageAspectRatio(1),
      },
    }),
  },
  imageContent: {
    flex: 1,
    justifyContent: 'flex-end',
    marginHorizontal: defaultScale(16),
  },
  doYouHaveAScale: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
  },
  useOurSmartScale: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    fontSize: scaleText(16),
    marginTop: defaultScale(15),
  },
  noScaleFindOutMore: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.PRIMARY,
    fontWeight: '700',
    marginBottom: defaultScale(22),
    marginTop: defaultScale(40),
    textAlign: 'center',
  },
  selectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
  selectionStyle: {
    marginBottom: defaultScale(24),
  },
  selectionSubtitle: {
    fontSize: Theme.textStyle.bodyCopyReg.fontSize,
    textAlign: 'center',
    marginTop: defaultScale(-8),
    fontFamily: Theme.textStyle.bodyCopyReg.fontFamily,
  },
  selectionContainer: {
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: defaultScale(16),
  },
});

export const WeightTargetFitillionScaleQuestion = translate(['weightTarget'])(
  WeightTargetFitillionScaleQuestionComponent,
);
